import React, {useRef, useState} from "react";
import {ManualBox2} from "../manualsBox/golf-products-manualsBox";

export const tabList = [
  {idx: 1, title : 'Features'},
  {idx: 2, title : 'Description'},
  {idx: 3, title : 'Specifications'},
  {idx: 4, title : 'Manuals'},
]
export const UPL2000 = () => {
  const [tabIndex, setTabIndex] = useState<number>(1)
  const scrollRef = [
    useRef<any>(null), useRef<any>(null), useRef<any>(null), useRef<any>(null), useRef<any>(null), useRef<any>(null), useRef<any>(null), useRef<any>(null), useRef<any>(null), useRef<any>(null)
  ];

  return (
    <>
      <div className="product_view upl2000">
        <div className="bgBox" style={{backgroundImage: "url('/assets/images/product/upl2000/banner.jpg')"}}>
          <section className="section_0">
            <div className="image-box">
              <div className="text-box">
                <p className="text-01">UPL2000</p>
                <p className="text-02">Engineered for Speed.<br/>
                  Designed to Fit.
                </p>
                <p className="text-03">Keep Your Rhythm - Check on the LCD</p>
                <ul style={{margin: '25px 0 0'}}>
                  <li>
                    <img src="/assets/images/product/upl2000/UPL2000_00_01.png" alt=""/>
                  </li>
                  <li>
                    <img src="/assets/images/product/upl2000/UPL2000_00_02.png" alt=""/>
                  </li>
                  <li>
                    <img src="/assets/images/product/upl2000/UPL2000_00_03.png" alt=""/>
                  </li>
                  <li>
                    <img src="/assets/images/product/upl2000/UPL2000_00_04.png" alt=""/>
                  </li>
                </ul>
                <ul style={{margin: '25px 0 0'}}>
                  <li>
                    <img src="/assets/images/product/upl2000/UPL2000_00_05.png" alt=""/>
                  </li>
                  <li>
                    <img src="/assets/images/product/upl2000/UPL2000_00_06.png" alt=""/>
                  </li>
                  <li>
                    <img src="/assets/images/product/upl2000/UPL2000_00_07.png" alt=""/>
                  </li>
                  <li>
                    <img src="/assets/images/product/upl2000/UPL2000_00_08.png" alt=""/>
                  </li>
                  <li>
                    <img src="/assets/images/product/upl2000/UPL2000_00_09.png" alt=""/>
                  </li>
                  <li>
                    <img src="/assets/images/product/upl2000/UPL2000_00_10.png" alt=""/>
                  </li>
                  <li>
                    <img src="/assets/images/product/upl2000/UPL2000_00_11.png" alt=""/>
                  </li>
                  <li>
                    <img src="/assets/images/product/upl2000/UPL2000_00_12.png" alt=""/>
                  </li>
                  <li>
                    <img src="/assets/images/product/upl2000/UPL2000_00_13.png" alt=""/>
                  </li>
                  <li>
                    <img src="/assets/images/product/upl2000/UPL2000_00_14.png" alt=""/>
                  </li>
                  <li>
                    <img src="/assets/images/product/upl2000/UPL2000_00_15.png" alt=""/>
                  </li>
                  <li>
                    <img src="/assets/images/product/upl2000/UPL2000_00_16.png" alt=""/>
                  </li>
                </ul>
              </div>
            </div>
          </section>
          <div className="scrollDownBox">
            <div>
              <span></span>
            </div>
            <span>SCROLL</span>
          </div>
        </div>

        <div className="tabWrap tabBtnWrapBattery">
          <div className="tabBtnWrap">
            <div className="tabBtnBox">
              {tabList.map((list:{idx:number,title:string})=>(
                <button className={tabIndex===list?.idx?'active':''} onClick={()=>setTabIndex(list?.idx)}>
                  {list?.title}
                </button>
              ))}
            </div>
          </div>


          <div className="tabContentBox">
            {tabIndex === 1 && <div className={`features active`}>
                <section className="section_6">
                    <div className="half">
                        <div className="text-area">
                            <div>
                                <p className="text-02">Crystal Clear External<br/> LCD Display</p>
                                <p className="text-03">Get instant readings on the external screen-<br/>
                                    no need to squint through the eyepiece again.</p>
                                <p className="text-04">Confirm your yardage at a glance and<br/>
                                    pick your club with confidence.</p>
                            </div>
                        </div>
                        <div className="image-area">
                            <img src="/assets/images/product/upl2000/UPL2000_en_amazon_06.jpg" alt=""/>
                        </div>
                    </div>
                </section>

                <section className="section_1">
                    <div className="half">
                        <div className="text-area">
                            <div>
                                <p className="text-01">No more struggling with your aim.</p>
                                <p className="text-02">Advanced Aiming Mode</p>
                                <p className="text-03">Lock onto the pin <em>to establish your target line</em><br/>
                                    Square your stance; the device vibrates the moment you reach<br/>
                                    perfect 90º alignment. </p>
                                <p className="text-04">Ensure a perfect setup for every shot.</p>
                            </div>
                        </div>
                        <div className="image-area">
                            <img src="/assets/images/product/upl2000/UPL2000_en_amazon_01.jpg" alt=""/>
                        </div>
                    </div>
                </section>

                <section className="section_4">
                    <div className="half">
                        <div className="text-area">
                            <div>
                                <p className="text-01">No more second-guessing your club.</p>
                                <p className="text-02">Smart Club Recommendation</p>
                                <p className="text-03">Enter your average distance for each club once.<br/>
                                    Once the distance is measured,<br/>
                                    the device suggests the ideal club for your shot.</p>
                                <p className="text-04">Simple. Precise. Personal.</p>
                            </div>
                        </div>
                        <div className="image-area">
                            <img src="/assets/images/product/upl2000/UPL2000_en_amazon_04_01.jpg" alt=""/>
                        </div>
                    </div>
                </section>

                <section className="section_7">
                    <p className="text-01">Distance Triangulation Mode (FineCaddie Mode)</p>
                    <p className="text-02">Measure anything, from anywhere</p>
                    <div className="image-box">
                        <img src="/assets/images/product/upl2000/UPL2000_en_amazon_07_01.jpg" alt=""/>
                        <img src="/assets/images/product/upl2000/UPL2000_en_amazon_07_02.jpg" alt=""/>
                        <img src="/assets/images/product/upl2000/UPL2000_en_amazon_07_03.jpg" alt=""/>
                    </div>
                </section>

                <section className="section_11">
                    <div className="half">
                        <div className="text-area">
                            <div>
                                <p className="text-01">Swing with confidence and lower your score.</p>
                                <p className="text-02">Ultra-Fast & Precise Pin Lock</p>
                                <p className="text-03">Lock onto the pin instantly with lightning-fast accuracy.</p>

                                <p className="text-04">＊Measured under internal test conditions. Actual performance may vary<br/>
                                    &nbsp;&nbsp;&nbsp;&nbsp;depending on environmental conditions such as weather and surroundings.</p>
                            </div>
                        </div>
                        <div className="image-area">
                            <img src="/assets/images/product/upl2000/UPL2000_en_amazon_11.jpg" alt=""/>
                        </div>
                    </div>
                </section>

                <section className="section_16">
                    <div className="imgBox">
                        <img src="/assets/images/product/upl2000/UPL2000_en_amazon_16_1464x600.jpg" alt=""/>
                    </div>
                </section>

                <section className="section_9">
                    <div className="half">
                        <div className="text-area">
                            <div>
                                <p className="text-02">Continuous Scanning for<br/>Faster Play</p>
                                <p className="text-03">Scan the flag and hazards instantly without slowing down your game.<br/>
                                    Scan Mode provides real-time distances-<br/>
                                    no repetitive button presses required.</p>
                                <p className="text-04">＊While Scan Mode is active, the center crosshair (+) will blink.</p>
                            </div>
                        </div>
                        <div className="image-area">
                            <img src="/assets/images/product/upl2000/UPL2000_en_amazon_09.jpg" alt=""/>
                        </div>
                    </div>
                </section>

                <section className="section_3">
                    <p className="text-01">How to Use Aiming Mode</p>
                    <div className="image-box">
                        <img src="/assets/images/product/upl2000/UPL2000_en_amazon_03_1464x600.jpg" alt=""/>
                    </div>
                </section>

                <section className="section_5">
                    <div className="imgBox">
                        <span>How to Use Smart Club Recommendation</span>
                        <img src="/assets/images/product/upl2000/UPL2000_en_amazon_05_1464x600.jpg" alt=""/>
                    </div>
                </section>

                <section className="section_8">
                    <p className="text-01">How to Use Distance Triangulation Mode (FineCaddie Mode)</p>
                    <div className="image-box">
                        <img src="/assets/images/product/upl2000/UPL2000_en_amazon_08_01.jpg" alt=""/>
                        <img src="/assets/images/product/upl2000/UPL2000_en_amazon_08_02.jpg" alt=""/>
                        <img src="/assets/images/product/upl2000/UPL2000_en_amazon_08_03.jpg" alt=""/>
                    </div>
                </section>

                <section className="section_10">
                    <p className="text-01">Quick & Easy Scan Mode</p>
                    <div className="imgBox">
                        <img src="/assets/images/product/upl2000/UPL2000_en_amazon_10.jpg" alt=""/>
                    </div>
                </section>

                <section className="section_15">
                    <p className="text-01">Slope Mode & Tournament Mode</p>
                    <p className="text-02">Slope Mode automatically calculates adjusted distances for any uphill or downhill shot.<br/>
                        Tournament Mode provides the legal, straight-line distance for competition.</p>
                    <div className="image-box">
                        <img src="/assets/images/product/upl2000/UPL2000_en_amazon_15_01.jpg" alt=""/>
                        <img src="/assets/images/product/upl2000/UPL2000_en_amazon_15_02.jpg" alt=""/>
                    </div>
                </section>

                <section className="section_12">
                    <div className="half">
                        <div className="text-area">
                            <div>
                                <p className="text-01">Steady Target Lock, Even with Shaky Hands.</p>
                                <p className="text-02">Pin Finder Mode</p>
                                <p className="text-03">Hold the Power button while aiming at the flag.<br/>
                                    A "Double Buzz" confirms the lock and displays your distance.</p>
                                <p className="text-04">If multiple targets are in view,<br/>
                                    the device prioritizes the nearest one (the pin).</p>
                            </div>
                        </div>
                        <div className="image-area">
                            <img src="/assets/images/product/upl2000/UPL2000_en_amazon_12.jpg" alt=""/>
                        </div>
                    </div>
                </section>

                <section className="section_13">
                    <div className="half">
                        <div className="text-area">
                            <div>
                                <p className="text-02">Haptic Vibration Alerts<br/> for Pin Lock</p>
                                <p className="text-03">Feel the lock. The device vibrates once it secures the flag.<br/>
                                    A distinct "Double Buzz" signals a successful pin lock.</p>
                            </div>
                        </div>
                        <div className="image-area">
                            <img src="/assets/images/product/upl2000/UPL2000_en_amazon_13.jpg" alt=""/>
                        </div>
                    </div>
                </section>

                <section className="section_14">
                    <div className="half">
                        <div className="text-area">
                            <div>
                                <p className="text-02">High-Precision Measurement<br/> Up to 800 Yards<br/>(In clear conditions)</p>
                                <p className="text-03">Reliable range from 5 to 800 yards with point-blank precision.<br/>
                                    From delicate chips to long-range drives,<br/>
                                    get pinpoint accuracy on every shot.</p>
                                <p className="text-04">＊ Please note that measurement accuracy may vary depending on weather<br/>
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;conditions such as heavy fog, rain, or overcast skies.</p>
                            </div>
                        </div>
                        <div className="image-area">
                            <img src="/assets/images/product/upl2000/UPL2000_en_amazon_14.jpg" alt=""/>
                        </div>
                    </div>
                </section>

                <section className="section_20">
                    <div className="half">
                        <div className="text-area">
                            <div>
                                <p className="text-02">Premium Design<br/>
                                    for a Refined Round</p>
                                <p className="text-03">Precision-engineered with an ergonomic,<br/>
                                    compact frame for a secure grip and effortless handling.<br/>
                                    Minimalist aesthetics and a premium finish<br/>
                                    blend style with on-course performance.</p>
                            </div>
                        </div>
                        <div className="image-area">
                            <img src="/assets/images/product/upl2000/UPL2000_en_amazon_20.jpg" alt=""/>
                        </div>
                    </div>
                </section>

                <section className="section_17">
                    <div className="half">
                        <div className="text-area">
                            <div>
                                <p className="text-02">IP54 Water & Dust Resistant</p>
                                <p className="text-03">Built to withstand dust, moisture, and light rain<br/>
                                    -giving you reliable readings in any weather.</p>
                                <p className="text-04">＊Damage caused by exposure beyond the IP54 rating—such as excessive dust,<br/>
                                    high water pressure, or immersion in water<br/>
                                    (keep as is, but remove 'washing machines, bathtubs, toilets')</p>
                            </div>
                        </div>
                        <div className="image-area">
                            <img src="/assets/images/product/upl2000/UPL2000_en_amazon_17.jpg" alt=""/>
                        </div>
                    </div>
                </section>

                <section className="section_18">
                    <div className="half">
                        <div className="text-area">
                            <div>
                                <p className="text-02">FineCaddie is committed to<br/>
                                    premium quality.</p>
                                <p className="text-03">We have integrated years of expertise in technology,<br/>
                                    quality control, and user experience.<br/>
                                    With pride in Korean engineering,<br/>
                                    we deliver our products to customers worldwide.</p>
                            </div>
                        </div>
                        <div className="image-area">
                            <img src="/assets/images/product/upl2000/UPL2000_en_amazon_18.jpg" alt=""/>
                        </div>
                    </div>
                </section>

                <section className="section_21">
                    <div className="half">
                        <div className="text-area">
                            <div>
                                <p className="text-02">Premium Magnetic Leather Case</p>
                                <p className="text-03">The magnetic leather case offers superior protection with quick,<br/>
                                    one-handed access during your round. Easily attach the case<br/>
                                    to your golf bag with the included premium carabiner.</p>
                                <p className="text-04">＊Carabiner clip included for easy attachment to your golf bag.<br/>
                                    ＊Avoid contact with light-colored clothing as minor color transfer may occur<br/>
                                    due to moisture or sweat.</p>
                            </div>
                        </div>
                        <div className="image-area">
                            <img src="/assets/images/product/upl2000/UPL2000_en_amazon_21.jpg" alt=""/>
                        </div>
                    </div>
                </section>

                <section className="section_19">
                    <div className="half">
                        <div className="text-area">
                            <div>
                                <p className="text-02">Pocket-Sized, Swing-Free</p>
                                <p className="text-03">Compact as a card and light on your waist.<br/>
                                    Designed for unrestricted movement on every swing.
                                </p>
                            </div>
                        </div>
                        <div className="image-area">
                            <img src="/assets/images/product/upl2000/UPL2000_en_amazon_19.jpg" alt=""/>
                        </div>
                    </div>
                </section>

                {/*<section className="section_22">
                    <p className="text-01">What's int the Box</p>
                    <p className="text-02">Check your package contents upon arrival<br/>Package contents may vary based on product enhancements.</p>
                    <div className="imgBox">
                        <img src="/assets/images/product/upl2000/UPL2000_en_amazon_22.jpg" alt=""/>
                    </div>
                </section>*/}
            </div>}
            {tabIndex === 2 && <div className={`whatsInTheBox active`}>
                <section>
                    <div className="imgBox">
                        <h3>Product Description</h3>
                        <img src="/assets/images/product/upl9mini/description.jpg" alt="Product Description"/>
                    </div>
                    <div className="imgBox" style={{marginBottom: '30px'}}>
                        <h3>WHAT’S IN THE BOX</h3>
                        <img src="/assets/images/product/upl2000/UPL2000_en_amazon_22.jpg" alt="Product Description"/>
                    </div>
                    <ul>
                        <li>※ Check your package contents upon arrival</li>
                        <li>※ Package contents may vary based on product enhancements.</li>
                    </ul>
                </section>
            </div>}
            {tabIndex === 3 && <div className={`specifications active`}>
                <div className="tableWrap">
                    <table>
                        <thead>
                        <tr>
                            <th>&nbsp;</th>
                            <th>UPL2000</th>
                            <th>Remark</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <th>Size/Weight</th>
                            <td>
                                3.4 x 2.0 x 1.2 in, 4.0 oz (87 x 51.8 x 31mm , 113g)
                            </td>
                            <td></td>
                        </tr>
                        <tr>
                            <th>Measuring range</th>
                            <td>
                                5-1125 Yards
                            </td>
                            <td>±(1.0yd + D×0.2%)</td>
                        </tr>
                        <tr>
                            <th>Measuring unit</th>
                            <td>m (Meter), Y (Yard)</td>
                            <td></td>
                        </tr>
                        <tr>
                            <th>Measuring speed</th>
                            <td>General measurement: 0.04 sec (Over 54.7Y: 0.1 sec)</td>
                            <td>Pin Finder measurement: 0.3 sec</td>
                        </tr>
                        <tr>
                            <th>Magnification</th>
                            <td>6X</td>
                            <td>±5%</td>
                        </tr>
                        <tr>
                            <th>Viewing angle</th>
                            <td>7.3°</td>
                            <td>±5%</td>
                        </tr>
                        <tr>
                            <th>Objective Lens Aperture</th>
                            <td>17.4 mm</td>
                            <td></td>
                        </tr>
                        <tr>
                            <th>Eyepiece Aperture</th>
                            <td>14 mm</td>
                            <td></td>
                        </tr>
                        <tr>
                            <th>Diopter Adjustment Range</th>
                            <td>±5.0dpt</td>
                            <td></td>
                        </tr>
                        <tr>
                            <th rowSpan={2}>Display</th>
                            <td rowSpan={2}>
                                (Inner) High‑transmittance LCD<br/>
                                (External) 1.69 inch TFT LCD
                            </td>
                            <td></td>
                        </tr>
                        <tr>
                            <td style={{borderLeft: '1px solid #EEEEEE'}}></td>
                        </tr>
                        <tr>
                            <th>Laser Spec.</th>
                            <td>Level : Class 1<br/>
                                Wavelength : 905nm ± 10nm<br/>
                                Pulse duration : ≤23ns<br/>
                                Output : &lt;1mW<br/>
                                Beam divergence : 1.3 mrad</td>
                            <td>IEC 60825-1</td>
                        </tr>
                        <tr>
                            <th>Battery Capacity</th>
                            <td>3.7 V / 520 mAh</td>
                            <td>Li-ion</td>
                        </tr>
                        <tr>
                            <th>Battery Life</th>
                            <td>Charging/discharging 300 times</td>
                            <td>Maximum charging time about 90 min</td>
                        </tr>
                        <tr>
                            <th>Battery Run Time</th>
                            <td>Based on actual field distance<br/>
                                measurements: 5,000 measurements</td>
                            <td>When fully charged</td>
                        </tr>
                        <tr>
                            <th>Waterproof</th>
                            <td>IP54</td>
                            <td></td>
                        </tr>
                        <tr>
                            <th>Operation temperature</th>
                            <td>14°F-122°F (-10 °C to 50 °C)</td>
                            <td></td>
                        </tr>
                        <tr>
                            <th>Height Measurement</th>
                            <td>Support</td>
                            <td></td>
                        </tr>
                        <tr>
                            <th>Pin Finder</th>
                            <td>Support</td>
                            <td></td>
                        </tr>
                        <tr>
                            <th>Scan Mode</th>
                            <td>Support</td>
                            <td></td>
                        </tr>
                        <tr>
                            <th>Club Suggestion</th>
                            <td>Support</td>
                            <td></td>
                        </tr>
                        <tr>
                            <th>Aiming Mode</th>
                            <td>Support</td>
                            <td></td>
                        </tr>
                        <tr>
                            <th>USB Charging Terminal</th>
                            <td>Support</td>
                            <td></td>
                        </tr>
                        <tr>
                            <td colSpan={3}>
                                Model Name : UPL2000<br/>
                                Name : Laser golf rangefinder<br/>
                                Manufacturer : FINEDIGITAL INC.<br/>
                                Manufacturing country : China<br/>
                                Date of manufacture : Separately marked<br/>
                                KC Certification Number : R-R-FDK-FineA080<br/>
                                Battery Registration Number : YU101097-22003
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>}
            {tabIndex === 4 && <ManualBox2/>}
          </div>
        </div>
      </div>
    </>
  )
}
